import { useState } from "react";
import { X, KeyRound } from "lucide-react";
import api from "../../services/api";

export default function ResetPasswordModal({ member, onClose }) {
  var _pwd = useState("");
  var pwd = _pwd[0];
  var setPwd = _pwd[1];
  var _loading = useState(false);
  var loading = _loading[0];
  var _done = useState(false);
  var done = _done[0];

  async function handleReset(e) {
    e.preventDefault();
    if (pwd.length < 6) return;
    _loading[1](true);
    try {
      await api.put("/users/" + member.id + "/reset-password", { new_password: pwd });
      _done[1](true);
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    } finally {
      _loading[1](false);
    }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm" data-testid="reset-password-modal">
        <div className="bg-white rounded-2xl shadow-2xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <KeyRound className="w-5 h-5 text-[#3B82F6]" />
              <h3 className="text-lg font-bold text-[#0A2F3D]">Resetar Senha</h3>
            </div>
            <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg"><X className="w-4 h-4 text-gray-400" /></button>
          </div>
          {done ? (
            <div>
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 text-center mb-4">
                <p className="text-sm font-medium text-emerald-700">Senha de {member.name} redefinida!</p>
                <p className="text-xs text-emerald-500 mt-1">A nova senha ja esta ativa.</p>
              </div>
              <button onClick={onClose} className="w-full px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB]">Fechar</button>
            </div>
          ) : (
            <form onSubmit={handleReset}>
              <p className="text-sm text-gray-500 mb-4">Defina uma nova senha para <strong>{member.name}</strong> ({member.email})</p>
              <input type="text" value={pwd} onChange={function (e) { setPwd(e.target.value); }}
                placeholder="Nova senha (minimo 6 caracteres)" minLength={6} required
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                data-testid="reset-password-input" />
              <div className="flex gap-3">
                <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
                <button type="submit" disabled={loading || pwd.length < 6}
                  className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50"
                  data-testid="reset-password-submit">
                  {loading ? "Resetando..." : "Resetar Senha"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
